import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import packageJson from '../../../../package.json'
import logoTtd from '../../assets/images/logo-ttd.png'
import HelpCenterCardSupportButton from '../Help/HelpCenterCardSupportButton'
import sxs from './_sxs'

function Info() {
    return (
        <Paper sx={sxs.paper}>
            <Card>
                <CardMedia sx={sxs.media} image={logoTtd} title="TokTokDoc" />
                <CardContent sx={sxs.cardContent}>
                    <Box sx={sxs.buttonContainer}>
                        <Typography sx={sxs.cardContentText}>
                            <strong> Version : {packageJson.version}</strong>
                        </Typography>

                        <HelpCenterCardSupportButton email />
                    </Box>

                    <Typography sx={sxs.cardContentText}>
                        <u>L'adresse ci-dessus n’est pas une messagerie sécurisée de santé</u>, et ne doit servir que
                        pour l'assistance technique aux utilisateurs. L'usage d'un courriel non sécurisé n'est pas
                        permis pour la transmission d’informations de santé.
                    </Typography>
                </CardContent>
            </Card>
        </Paper>
    )
}

export default Info
